<template>
  <div class="animated fadeIn">
    <b-row v-if="loading">
      <b-col md="6">
        <atom-spinner
          :animation-duration="1000"
          :size="60"
          color="#ff1d5e"
          class="float-right my-5"
        />
      </b-col>
    </b-row>
    <b-row v-if="!loading">
      <b-col>
        <component-header
          title="View Service Request"
          :hasSearch="false"
          :hasReload="false"
          :hasCreate="false"
          :hasback="true"
          @back-press="$router.push('/setup/service-request')"
        />
      </b-col>
      <b-col md="12">
        <b-card>
          <b-row>
            <b-col sm="6">
              <b-form-group label="Scope" label-for="Scope" :label-cols="3">
                <b-form-input
                  type="text"
                  id="scope"
                  placeholder="Scope"
                  v-model="itemObj.Scope"
                  disabled
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group
                label="Category"
                label-for="Category"
                :label-cols="3"
              >
                <b-form-input
                  type="text"
                  id="category"
                  v-model="itemObj.Category"
                  placeholder="Category"
                  disabled
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="6">
              <b-form-group label="Topic" label-for="Topic" :label-cols="3">
                <b-form-input
                  type="text"
                  id="topic"
                  placeholder="Topic"
                  disabled
                  v-model="itemObj.topic"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group
                label="Description"
                label-for="Description"
                :label-cols="3"
              >
                <b-form-input
                  type="text"
                  id="description"
                  placeholder="Description"
                  disabled
                  v-model="itemObj.description"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <eb-button
                class="btn float-right mr-4"
                classic="mr-1 btn-primary"
                text="Add Sub Category"
                icon="fa fa-plus-circle mr-1"
                iconSide="left"
                @click="category()"
              ></eb-button>
            </b-col>
            <b-col md="12">
              <b-table
                style="border-radius: 12px"
                :dark="dark"
                :hover="hover"
                :striped="striped"
                :bordered="bordered"
                :small="small"
                :fixed="fixed"
                responsive
                id="my-table"
                :items="subcategories"
                :current-page="currentPage"
                :per-page="perPage"
                thead-class="header"
                class="mt-3"
                :fields="Columns"
              ></b-table
            ></b-col>
          </b-row>

          <b-row>
            <b-col md="6">
              <!-- <eb-button
                classic="mr-1 btn-primary"
                text="Back"
                @click="e => $emit('view', e)"
              ></eb-button> -->
            </b-col>
            <b-col>
              <div style="float: right">
                <b-pagination
                  v-model="currentPage"
                  :per-page="perPage"
                  :total-rows="subcategories.length"
                  aria-controls="my-table"
                  prev-text="Prev"
                  next-text="Next"
                  hide-goto-end-buttons
                ></b-pagination>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import cInput from "@/components/Common/CustomInput";
import ebSelect from "@/components/FormElements/Select.vue";
import ebButton from "@/components/FormElements/Button";
import subcategory from "@/components/MasterSetup/ServiceRequest/Subcategory.vue";
import ComponentHeader from "@/components/componentNewHeader";
import { AtomSpinner } from "epic-spinners";
export default {
  name: "Viewrequest",
  components: {
    ebButton,
    cInput,
    ebSelect,
    subcategory,
    ComponentHeader,
    AtomSpinner,
  },
  data: () => {
    return {
      itemObj: {},
      perPage: 5,
      striped: false,
      hover: true,
      bordered: true,
      small: false,
      dark: false,
      fixed: false,
      currentPage: 1,
      loading: false,
      Columns: [
        {
          key: "Category",
          sortable: true,
        },
        {
          key: "Description",
        },
        {
          key: "Scope",
        },

        {
          key: "Severity",
        },
      ],
    };
  },
  computed: {
    subcategories() {
      let data = this.$store.getters["servicerequest/GetSubcategoryList"];
      let SubcategoryList = [];
      if (Array.isArray(data.data) && data.data.length > 0) {
        data.data.map((obj) => {
          // for (let i = 0; i < obj.data.length; i++) {
          let arrayObj = {
            Category: obj.name,
            Description: obj.description,
            Scope: obj.scope,
            Severity: obj.severity,
            id: obj._id,
            ...obj,
          };
          SubcategoryList.push(arrayObj);
          // }
        });
        return SubcategoryList;
      } else {
        this.loading = false;
        return [];
      }
    },
    // userRole() {
    //   if (this.$store.getters["auth/getUserRole"]) {
    //     return this.$store.getters["auth/getUserRole"];
    //   } else {
    //     return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
    //   }
    // }
  },
  methods: {
    category() {
      this.$router.push({
        name: "Subcategory",
        params: { id: this.itemObj.id, data: this.itemObj },
      });
    },
  },
  async mounted() {
    this.loading = true;
    this.itemObj = { ...this.$route.params.data };
    try {
      await this.$store.dispatch(
        "servicerequest/fetchsubcategoryList",
        this.itemObj.id
      );
    } catch (error) {
      this.$toasted.error(data.message);
    } finally {
      this.loading = false;
    }
  },
};
</script>
<style scoped>
.fa-plus {
  border-top-right-radius: 10px;
  border-top-left-radius: 17px;
  border-bottom-left-radius: 17px;
  background-color: #f0f3f5;
}
</style>
